// Action types
export const DASHBOARD_LOAD_REQUEST = "DASHBOARD_LOAD_REQUEST";
export const DASHBOARD_LOAD_SUCCESS = "DASHBOARD_LOAD_SUCCESS";
export const DASHBOARD_LOAD_ERROR = "DASHBOARD_LOAD_ERROR";

// Action creators
export const loadDashboardData = (startDate, endDate, rangeKey = "custom") => ({
  type: DASHBOARD_LOAD_REQUEST,
  payload: { startDate, endDate, rangeKey }
});

export const loadDashboardDataSuccess = data => ({
  type: DASHBOARD_LOAD_SUCCESS,
  payload: data
});

export const loadDashboardDataError = error => ({
  type: DASHBOARD_LOAD_ERROR,
  payload: error
});
